import React from 'react';
import { ChineseZodiacSign } from '../types';

interface ChineseZodiacIconProps {
  sign: ChineseZodiacSign;
  className?: string;
}

const ChineseZodiacIcon: React.FC<ChineseZodiacIconProps> = ({ sign, className }) => {
  const getIcon = () => {
    switch (sign) {
      case ChineseZodiacSign.Rat:
        return '🐀';
      case ChineseZodiacSign.Ox:
        return '🐂';
      case ChineseZodiacSign.Tiger:
        return '🐅';
      case ChineseZodiacSign.Rabbit:
        return '🐇';
      case ChineseZodiacSign.Dragon:
        return '🐉';
      case ChineseZodiacSign.Snake:
        return '🐍';
      case ChineseZodiacSign.Horse:
        return '🐎';
      case ChineseZodiacSign.Goat:
        return '🐐';
      case ChineseZodiacSign.Monkey:
        return '🐒';
      case ChineseZodiacSign.Rooster:
        return '🐓';
      case ChineseZodiacSign.Dog:
        return '🐕';
      case ChineseZodiacSign.Pig:
        return '🐖';
      default:
        return '✨';
    }
  };

  return <div className={className}>{getIcon()}</div>;
};

export default ChineseZodiacIcon;
